import { Box, Typography } from "@mui/material";

export function getFlexElInformationText() {
  return (
    <Box>
      <Box>
        <Typography variant="body1">
          Med FlexEl har du en variabel elpris, der følger priserne på den
          nordiske elbørs time for time. Det betyder, at du kan spare penge ved
          at bruge strømmen, når den er billigst.
        </Typography>
        <Typography variant="body1" mt={1}>
          Lær mere i denne korte{" "}
          {getLinkElement(
            "video om FlexEl",
            "https://norlys.dk/el/flexel/#video",
          )}
          .
        </Typography>
        <Typography variant="body1" mt={1}>
          Den viste elpris for FlexEl er sidste måneds gennemsnitspris. Din
          faktiske pris afhænger af elprisen i netop de timer, hvor du bruger
          strømmen. Du kan følge{" "}
          {getLinkElement(
            "de aktuelle priser her",
            "https://norlys.dk/el/elpriser/",
          )}{" "}
          eller i vores prisvindende{" "}
          {getLinkElement(
            "Norlys-app",
            "https://norlys.dk/norlys-appen/energi/",
          )}
          .
        </Typography>
        <Box mt={4}>
          <Typography variant="body1bold">Elprisen</Typography>
          <Typography variant="body1" mt={1}>
            Elprisen består af tre dele:
          </Typography>

          <Box component="ul" sx={{ ml: 2, pl: 2 }}>
            {getListElement(
              "Spotprisen",
              "Vores indkøbspris på elbørsen Nord Pool. Prisen er variabel og skifter hver time.",
            )}
            {getListElement(
              "Handelsomkostninger",
              "Vores omkostninger ved at købe strøm på elbørsen og sikre balance mellem forventet og faktisk forbrug. Prisen er variabel og justeres to gange om året (1. januar og 1. juli), så den svarer til de faktiske omkostninger. Prisen på bestillingstidspunktet vil fremgå på din kontrakt, og den aktuelle pris kan altid ses på <a href='https://norlys.dk/el/flexel' target='_blank'>norlys.dk/el/flexel.</a>",
            )}
            {getListElement(
              "Administrationstillæg",
              "Vores faste tillæg for administration af elhandlen.",
            )}
          </Box>
        </Box>

        <Typography variant="body1" mt={2}>
          Summen af handelsomkostninger og administrationstillæg kalder vi for
          ”pristillæg”.
        </Typography>
      </Box>

      <Box mt={4}>
        <Typography fontWeight={"bold"}>
          Pristillæg 1. juli - 31. december 2026
        </Typography>
        <Typography variant="body1">
          Handelsomkostninger: 0,70 øre/kWh
        </Typography>
        <Typography variant="body1">
          Administrationstillæg: 9,00 øre/kWh
        </Typography>
        <Typography variant="body1">I alt: 9,70 øre/kWh</Typography>
      </Box>

      <Box mt={4}>
        <Typography fontWeight={"bold"}>Transport og afgifter</Typography>
        <Typography>
          Alle elselskaber er forpligtet til at opkræve transport, tariffer og
          afgifter på vegne af:
        </Typography>
        <Box component="ul" sx={{ ml: 2, mt: 2, pl: 2 }}>
          <Typography component="li">Dit lokale elnetselskab</Typography>
          <Typography component="li">Energinet</Typography>
          <Typography component="li">Staten</Typography>
        </Box>
      </Box>

      <Box mt={4}>
        <Typography fontWeight={"bold"}>Abonnement</Typography>
        <Typography>
          Du betaler et månedligt abonnement på 29 kr. for at være kunde hos os
          i Norlys. Derudover betaler du abonnement til dit elnetselskab og
          Energinet.
        </Typography>
        <Typography>
          Bliv klogere på,{" "}
          <a
            href="https://norlys.dk/kundeservice/el/elregning/maanedsregning/"
            target="_blank"
          >
            hvem du betaler til, og hvad du betaler for
          </a>
        </Typography>
      </Box>

      <Box mt={4}>
        <Typography fontWeight={"bold"}>Samlet pris</Typography>
        <Typography>Den samlede kWh-pris består af:</Typography>
        <Box component="ul" sx={{ ml: 2, mt: 2, pl: 2 }}>
          <Typography component="li">Elprisen</Typography>
          <Typography component="li">Transport og afgifter</Typography>
        </Box>
        <Typography mt={4}>
          Prisen er inklusiv moms og eksklusiv abonnementer.
          Prisen forudsætter, at du vælger
          automatisk kortbetaling, som er gebyrfrit. Du kan også vælge
          Betalingsservice mod et gebyr på 6,75 kr. pr. regning. Hvis du ikke
          vælger betalingsform, skal du betale et gebyr på 49 kr. pr. regning.
        </Typography>
      </Box>
    </Box>
  );
}

export function getMånedsElInformationText() {
  return (
    <Box>
      <Box>
        <Typography variant="body1">
          Med MånedsEl har du en fast elpris, der er låst for en måned ad
          gangen. Det giver dig tryghed samtidig med, at prisen løbende
          afspejler udviklingen i markedet.
        </Typography>
        <Typography variant="body1" mt={1}>
          Lær mere i denne korte{" "}
          {getLinkElement(
            "video om MånedsEl",
            "https://norlys.dk/el/maanedsel/#video",
          )}
          .
        </Typography>
        <Typography variant="body1">
          Du kan følge elprisen i vores prisvindende{" "}
          {getLinkElement(
            "Norlys-app",
            "https://norlys.dk/norlys-appen/energi/",
          )}
        </Typography>

        <Box mt={4}>
          <Typography variant="body1bold">Elprisen</Typography>
          <Typography>
            Prisen på MånedsEl bliver reguleret hver måned. Prisen er fast og
            består af:
          </Typography>
        </Box>

        <Box mt={2}>
          <Box component="ul" sx={{ ml: 2, pl: 2 }}>
            {getListElement(
              "Indkøbsprisen",
              "Indkøbsprisen bliver fastsat ud fra den pris, som strømmen i dit prisområde kan indkøbes til på elbørsen NASDAQ måneden forinden – baseret på det forventede forbrug. Dertil kommer et variabelt profiltillæg, som bliver fastsat på baggrund af den gennemsnitlige, forventede forbrugs- og prisprofil i dit område i den pågældende måned.",
            )}
            {getListElement(
              "Handelsomkostningerne",
              "Vores omkostninger ved at købe strøm på elbørsen og sikre balance mellem forventet og faktisk forbrug. Prisen er variabel og justeres to gange om året (1. januar og 1. juli), så den svarer til de faktiske omkostninger. Du kan altid finde den aktuelle sats på norlys.dk/el/maanedsel.",
            )}
            {getListElement(
              "Administrationstillæg",
              "Vores faste tillæg for administration af elhandlen.",
            )}
          </Box>
        </Box>

        <Typography variant="body1" mt={2}>
          Den viste elpris for MånedsEl er prisen for indeværende måned og kan
          variere fra din kommende faktiske månedspris, hvis din elaftale
          begynder i en senere måned. Elprisen bliver ændret 12 gange om året.
        </Typography>
      </Box>

      <Box mt={4}>
        <Typography fontWeight={"bold"}>Transport og afgifter</Typography>
        <Typography>
          Alle elselskaber er forpligtet til at opkræve transport, tariffer og
          afgifter på vegne af:
        </Typography>
        <Box component="ul" sx={{ ml: 2, mt: 2, pl: 2 }}>
          <Typography component="li">Dit lokale elnetselskab</Typography>
          <Typography component="li">Energinet</Typography>
          <Typography component="li">Staten</Typography>
        </Box>

        <Typography mt={2}>
          Beløbene sendes direkte fra dig til dem, uændret og uden gebyrer.
        </Typography>
        <Typography>
          Den viste pris er et eksempel fra elnetselskabet N1. Dine endelige
          priser står på din kontrakt.
        </Typography>
      </Box>

      <Box mt={4}>
        <Typography fontWeight={"bold"}>Abonnement</Typography>
        <Typography>
          Du betaler et månedligt abonnement på 29 kr. for at være kunde hos os
          i Norlys. Derudover betaler du abonnement til dit elnetselskab og
          Energinet.
        </Typography>
        <Typography>
          Bliv klogere på,{" "}
          <a
            href="https://norlys.dk/kundeservice/el/elregning/maanedsregning/"
            target="_blank"
          >
            hvem du betaler til, og hvad du betaler for
          </a>
        </Typography>
      </Box>
      <Box mt={4}>
        <Typography fontWeight={"bold"}>Samlet pris</Typography>
        <Typography>Den samlede kWh-pris består af:</Typography>
        <Box component="ul" sx={{ ml: 2, mt: 2, pl: 2 }}>
          <Typography component="li">Elprisen</Typography>
          <Typography component="li">Transport og afgifter</Typography>
        </Box>
        <Typography mt={4}>
          Prisen er inklusiv moms og eksklusiv abonnementer. 
          Prisen forudsætter, at du vælger
          automatisk kortbetaling, som er gebyrfrit. Du kan også vælge
          Betalingsservice mod et gebyr på 6,75 kr. pr. regning. Hvis du ikke
          vælger betalingsform, skal du betale et gebyr på 49 kr. pr. regning.
        </Typography>
      </Box>
    </Box>
  );
}

export function getKombiElInformationText() {
  return (
    <Box>
      <Box>
        <Typography variant="body1bold">Bliv klogere på KombiEl</Typography>
        <Typography variant="body1" mt={1}>
          Med KombiEl har du mulighed for at udnytte fordelene ved både en fast
          og variabel timepris. Derfor er KombiEl et godt valg til dig, som
          ønsker en elaftale, hvor en del af prisen varierer, mens du samtidig
          er sikret en fast pris, der minimerer store prisudsving.
        </Typography>
        <Typography variant="body1" mt={2}>
          KombiEl giver dig en elpris, hvor halvdelen af dit forbrug afregnes
          til en fast pris, og den anden halvdel til en variabel timepris. Du
          kan derfor med fordel forsøge at flytte fx tøjvasken til de billigste
          timer, mens du samtidig er sikret mod større prishop i den forkerte
          retning, fordi halvdelen af din elpris er fast et kvartal ad gangen.
        </Typography>
        <Typography variant="body1" mt={2}>
          Din elpris følger løbende markedsudviklingen både på kort og lang
          sigt.
        </Typography>
        <Typography variant="body1" mt={2}>
          <a
            href="https://norlys.dk/el/kombiel/#video"
            target="_blank"
            rel="noreferrer"
          >
            Se video om KombiEl
          </a>
        </Typography>
        <Typography variant="body1" mt={2}>
          <a
            href="https://norlys.dk/el/elpriser/#prisudvikling"
            target="_blank"
            rel="noreferrer"
          >
            Se den historiske prisudvikling for KombiEl
          </a>
        </Typography>
      </Box>
    </Box>
  );
}

export function getChargingStandEjeInformationText() {
  return (
    <Box>
      <Box>
        <Typography variant="body1bold">
          Bliv klogere på din ladeløsning
        </Typography>
        <Typography variant="body1" mt={1}>
          Hos Norlys får du en intelligent ladeboks, som er nem at betjene. Du
          vælger selv, om du vil leje eller købe din ladeboks.
        </Typography>
        <Typography variant="body1" mt={2}>
          Hvis du lejer din ladeboks, er startprisen lav, og derefter har du en
          fast, månedlig lejepris. Køber du i stedet ladeboksen, er din
          startpris højere end ved leje, men din månedlige pris er lavere.
        </Typography>
      </Box>
    </Box>
  );
}

export function getChargingStandLejeInformationText() {
  return (
    <Box>
      <Box>
        <Typography variant="body1bold">
          Bliv klogere på din leje ladeløsning
        </Typography>
        <Typography variant="body1" mt={1}>
          Hos Norlys får du en intelligent ladeboks, som er nem at betjene. Du
          vælger selv, om du vil leje eller købe din ladeboks.
        </Typography>
        <Typography variant="body1" mt={2}>
          Hvis du lejer din ladeboks, er startprisen lav, og derefter har du en
          fast, månedlig lejepris. Køber du i stedet ladeboksen, er din
          startpris højere end ved leje, men din månedlige pris er lavere.
        </Typography>
      </Box>
    </Box>
  );
}

function getLinkElement(text: string, url: string) {
  return (
    <a href={url} target="_blank" rel="noreferrer">
      {text}
    </a>
  );
}

function getListElement(title: string, text: string) {
  return (
    <Typography component="li" sx={{ mt: 2 }}>
      <b>{title}</b>
      <Typography component="div" sx={{ mt: 1 }}>
        <span dangerouslySetInnerHTML={{ __html: text }}></span>
      </Typography>
    </Typography>
  );
}
